import { render, staticRenderFns } from "./AppointLogistics.vue?vue&type=template&id=d8a07b30"
import script from "./AppointLogistics.vue?vue&type=script&lang=js"
export * from "./AppointLogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8a07b30')) {
      api.createRecord('d8a07b30', component.options)
    } else {
      api.reload('d8a07b30', component.options)
    }
    module.hot.accept("./AppointLogistics.vue?vue&type=template&id=d8a07b30", function () {
      api.rerender('d8a07b30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/source/components/AppointDelivery/AppointLogistics.vue"
export default component.exports